








































import { i18n } from "@/resources/locales";
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
@Component({
  name: "confirm-ban-modal-component",
})
export default class ConfirmModalComponent extends mixins(UserValidator) {
  isAdminByUser = false;
  isSuperSpaceOwnerByUser = false;
  get active(): boolean {
    return this.$store.getters["SystemStore/getConfirmBanModal"];
  }
  set active(e: boolean) {
    this.$store.dispatch("SystemStore/setConfirmModalBanAction", e);
  }
  mounted(): void {
    const id = this.$store.getters["SystemStore/getConfirmBanModalData"];
    this.$store.dispatch("UserStore/getUserByIdAction", {
      userId: id,
      callback: (data) => {
        this.isAdminByUser = this.isAdminBySpaceUser(data);
        this.isSuperSpaceOwnerByUser = this.isSuperSpaceOwnerByUserSpace(data);
      },
    });
  }
  confirm(): void {
    const id = this.$store.getters["SystemStore/getConfirmBanModalData"];
    this.active = false;
    this.$store.dispatch("SpaceUserStore/enableUserAction", {
      spaceId: id,
      data: { enabled: false },
      callback: async (user) => {
        this.$vs.notification({
          color: "success",
          title: i18n.t("notifications.titles.success"),
          text: i18n.t("notifications.descriptions.userBan"),
        });
      },
      callbackError(error) {
        this.$vs.notification({
          title: i18n.t("notifications.titles.error"),
          text: i18n.t("notifications.genericError.genericErrorRetry"),
        });
      },
    });
  }
}
